const GENERIC_TITLE = "Рієстро";
const GENERIC_DESCRIPTION =
  "Рієстро — платформа для рієлторів та клієнтів: пошук нерухомості, оголошення, спілкування.";

const CREATED_ATTR = "data-riestro-presentation-meta";

function snapshotAttribute(el, name) {
  if (!el || !el.hasAttribute(name)) return { present: false, value: null };
  return { present: true, value: el.getAttribute(name) };
}

function restoreAttribute(el, name, snapshot) {
  if (!el) return;
  if (snapshot.present) {
    el.setAttribute(name, snapshot.value == null ? "" : snapshot.value);
    return;
  }
  el.removeAttribute(name);
}

function snapshotMeta(selector) {
  const el = document.head.querySelector(selector);
  if (!el) {
    return { existed: false, content: null };
  }
  return { existed: true, content: el.getAttribute("content") };
}

function upsertMeta(selector, identityAttributes, content) {
  let el = document.head.querySelector(selector);
  let created = false;
  if (!el) {
    el = document.createElement("meta");
    Object.entries(identityAttributes).forEach(([key, value]) => {
      el.setAttribute(key, value);
    });
    el.setAttribute(CREATED_ATTR, "created");
    document.head.appendChild(el);
    created = true;
  }
  el.setAttribute("content", content);
  return { el, created };
}

function restoreMeta(selector, snapshot) {
  const el = document.head.querySelector(selector);
  if (snapshot.existed) {
    if (!el) return;
    if (snapshot.content == null) {
      el.removeAttribute("content");
    } else {
      el.setAttribute("content", snapshot.content);
    }
    return;
  }
  if (el && el.getAttribute(CREATED_ATTR) === "created") {
    el.remove();
  }
}

export function applyPublicPresentationDocumentMeta({ title } = {}) {
  if (typeof document === "undefined") return undefined;

  const previousTitle = document.title;
  const htmlEl = document.documentElement;
  const previousLang = snapshotAttribute(htmlEl, "lang");

  const robots = snapshotMeta('meta[name="robots"]');
  const referrer = snapshotMeta('meta[name="referrer"]');
  const description = snapshotMeta('meta[name="description"]');
  const ogTitle = snapshotMeta('meta[property="og:title"]');
  const ogDescription = snapshotMeta('meta[property="og:description"]');
  const ogType = snapshotMeta('meta[property="og:type"]');

  const visibleTitle = title && String(title).trim() ? String(title).trim() : GENERIC_TITLE;
  document.title = visibleTitle;
  if (htmlEl) {
    htmlEl.setAttribute("lang", "uk");
  }

  upsertMeta('meta[name="robots"]', { name: "robots" }, "noindex, nofollow");
  upsertMeta('meta[name="referrer"]', { name: "referrer" }, "no-referrer");
  upsertMeta('meta[name="description"]', { name: "description" }, GENERIC_DESCRIPTION);
  upsertMeta('meta[property="og:title"]', { property: "og:title" }, GENERIC_TITLE);
  upsertMeta(
    'meta[property="og:description"]',
    { property: "og:description" },
    GENERIC_DESCRIPTION,
  );
  upsertMeta('meta[property="og:type"]', { property: "og:type" }, "website");

  return () => {
    document.title = previousTitle;
    restoreAttribute(htmlEl, "lang", previousLang);
    restoreMeta('meta[name="robots"]', robots);
    restoreMeta('meta[name="referrer"]', referrer);
    restoreMeta('meta[name="description"]', description);
    restoreMeta('meta[property="og:title"]', ogTitle);
    restoreMeta('meta[property="og:description"]', ogDescription);
    restoreMeta('meta[property="og:type"]', ogType);
  };
}

export { GENERIC_TITLE, GENERIC_DESCRIPTION };
